import React, { Component } from 'react';
import TimeUtils from '../../utils/TimeUtils';
import ClosedQuestion from "./ClosedQuestion";
import OpenQuestion from "./OpenQuestion";
import GapQuestion from "./GapQuestion";

import './css/TestEditor.css';
import Header from "./Header";
import SelectQuestion from "./SelectQuestion";
import API from "../../api/API";

class TestEditor extends Component {
    constructor(props) {
        super(props);

        this.state = {
            test_id: 0,
            name: '',
            newItem: 'header',
            time: 0,
            timeLeft: 0,
            answers: []
        };

        this.questions = this.state.questions;
    }

    componentDidMount() {
        this.loadTest();
    }

    loadTest = () => {
        API.callAPI('tests/?id=' + this.props.id)
            .then(response => {
                if(!response['error']) {
                    console.log(response.test);
                    this.questions = JSON.parse(response.test || "[]");
                    const answers = JSON.parse(response.answers || "[]");
                    this.setState({
                        test_id: response.test_id,
                        name: response.name,
                        time: response.time,
                        questions: this.questions,
                        timeLeft: response.time * 60,
                        answers: answers
                    });
                }
            });
    }

    saveCorrectAnswer = (question, answer) => {
        const answers = this.state.answers;
        answers[question] = answer;
        this.setState({ answers: answers });
    };

    saveAnswers = (question, answers) => {
        const questions = this.questions;
        questions[question].answers = answers;
        this.setState({ questions: questions });
    };

    setSubtasks = (question, subtasks) => {
        const questions = this.questions;
        questions[question].subtasks = subtasks;
        this.setState({ questions: questions });
    };

    setMultipleChoice = (question, multipleChoice) => {
        const questions = this.questions;
        questions[question].multipleChoice = multipleChoice;
        this.setState({ questions: questions });
    };

    setShuffle = (question, shuffle) => {
        const questions = this.questions;
        questions[question].shuffle = shuffle;
        this.setState({ questions: questions });
    };

    setQuestion = (questionNumber, question) => {
        const questions = this.questions;
        questions[questionNumber].question = question;
        this.setState({ questions: questions });
    };

    setHeader = (questionNumber, question) => {
        const questions = this.questions;
        questions[questionNumber].header = question;
        this.setState({ questions: questions });
    };

    setDescription = (questionNumber, description) => {
        const questions = this.questions;
        questions[questionNumber].description = description;
        this.setState({ questions: questions });
    };

    setMultiline = (questionNumber, multiline) => {
        const questions = this.questions;
        questions[questionNumber].multiline = multiline;
        this.setState({ questions: questions });
    };

    deleteQuestion = (questionNumber) => {
        const questions = this.questions;
        questions.splice(questionNumber, 1);
        const answers = this.state.answers;
        answers.splice(questionNumber, 1);
        this.setState({ questions: questions, answers: answers });
    };

    addMinute = () => {
        const timeLeft = this.state.timeLeft + 60;
        this.setState({ timeLeft: timeLeft, time: this.state.time + 1 });
    };

    removeMinute = () => {
        const timeLeft = this.state.timeLeft - 60;
        this.setState({ timeLeft: timeLeft < 60 ? 60 : timeLeft, time: this.state.time - 1 });
    };

    selectNew = (event) => {
        this.setState({ newItem: event.target.value });
    };

    addElement = () => {
        const itemType = this.state.newItem;
        const item = {
            "uniqueId": itemType + new Date().getUTCMilliseconds(),
            "type": itemType
        };

        if (itemType === "header") {
            item.header = '';
            item.description = '';
        } else {
            item.question = '';
        }

        if (itemType === "closed") {
            item.answers = [];
            item.shuffle = false;
            item.multipleChoice = false;
        }

        if (itemType === "open") {
            item.multiline = false;
            item.points = 1;
        }

        if (itemType === "gap") {
            item.subtasks = [];
            item.shuffle = false;
        }

        if (itemType === "select") {
            item.subtasks = [];
            item.options = [];
            item.shuffle = false;
        }

        const questions = this.state.questions;
        questions.push(item);

        this.setState({ questions: questions });
    };

    move = (id, dif) => {
        const questions = this.state.questions;
        const answers = this.state.answers;

        let swap = questions[id];
        questions[id] = questions[id + dif];
        questions[id + dif] = swap;

        swap = answers[id];
        answers[id] = answers[id + dif];
        answers[id + dif] = swap;

        this.setState({ questions: questions, answers: answers });
    };

    setPoints = (id, points) => {
        const questions = this.state.questions;
        let questionPoints = points;
        if (questionPoints < 0) questionPoints = 0;
        questions[id].points = questionPoints;
        this.setState({ questions: questions })
    };

    setName = (event) => {
        this.setState({ name: event.target.value });
    };

    save = () => {
        const saveTest = () => {
            API.callAPI('tests/', 'PUT', {
                "test_id": this.state.test_id,
                "name": this.state.name,
                "time": this.state.time,
                "test": JSON.stringify(this.state.questions),
                "answers": JSON.stringify(this.state.answers)
            }).then(() => {
                this.setState({ questions: undefined }, () => {this.loadTest()});
            });
        };

        API.callAPI('tests/return/?test_id=' + this.state.test_id)
            .then(response => {
                if (response.length > 0) {
                    const userIsSure = window.confirm("Zapisanie testu usunie prace uczniów. Kontynuować?");
                    if (userIsSure) {
                        saveTest();
                    }
                } else {
                    saveTest();
                }
            });
    };

    render() {
        const timeLeft = this.state.timeLeft;
        let i = 0;
        let number = 1;
        let questions = <div className="loader-wrapper"><div className="loader" /></div>;
        if (this.state.questions) {
            questions = this.state.questions.map(question => {
                const task = this.createTask(question, i, number);
                i += 1;
                if (question['type'] !== 'header') number += 1;
                return task;
            });
        }
        return (
            <div className="test test-edit">
                <div className="toolbar">
                    <div className="toolbar-content">
                        <div className="">
                            <button className="btn-square" onClick={this.props.openList}><i className="fas fa-chevron-left"></i></button>
                        </div>
                        <div className="name">
                            <input type="text" className="name-value" value={this.state.name} onChange={this.setName} />
                        </div>
                        <div className="time"><span className={"time-left " + (timeLeft < 10 * 60 ? "time-left-red" : "")}>{TimeUtils.format(timeLeft)}</span>
                            <button className="btn-square" onClick={this.addMinute}><i className="fas fa-plus" /></button>
                            <button className="btn-square" onClick={this.removeMinute}><i className="fas fa-minus" /></button>
                        </div>
                        <div className=""><button className="btn-square" onClick={this.save}>Zapisz</button></div>
                    </div>
                </div>
                <div className="">
                    {questions}
                </div>
                {this.state.questions ? <div className="add-element">
                    <span className="add-label">Dodaj</span>
                    <select onChange={this.selectNew} value={this.state.newItem}>
                        <option value="header">Nagłówek/opis</option>
                        <option value="closed">Zamknięte pytanie</option>
                        <option value="open">Otwarte pytanie</option>
                        <option value="gap">Uzupełnianie luk</option>
                        {/*<option value="select">Wybór</option>*/}
                    </select>
                    <button className="btn-square" onClick={this.addElement}><i className="fas fa-plus" /></button>
                </div> : ''}
            </div>
        )
    }

    createTask(question, id, number) {
        let elementKey = "question-" + question.uniqueId;
        const isFirst = id === 0;
        const isLast = id === this.state.questions.length - 1;

        const moveUp = () => {
            this.move(id, -1);
        };

        const moveDown = () => {
            this.move(id, 1);
        };

        if (question['type'] === "closed") {
            return (
                <ClosedQuestion
                    key={elementKey}
                    id={id}
                    number={number}
                    question={question.question}
                    answers={question.answers}
                    correctAnswers={this.state.answers[id]}
                    multipleChoice={question.multipleChoice}
                    shuffle={question.shuffle}
                    saveAnswer={this.saveCorrectAnswer}
                    setAnswers={this.saveAnswers}
                    setShuffle={this.setShuffle}
                    setMultipleChoice={this.setMultipleChoice}
                    setQuestion={this.setQuestion}
                    deleteQuestion={this.deleteQuestion}
                    moveUp={moveUp}
                    moveDown={moveDown}
                    isFirst={isFirst}
                    isLast={isLast}
                />)
        }

        if (question['type'] === "open") {
            return (
                <OpenQuestion
                    key={elementKey}
                    id={id}
                    number={number}
                    question={question.question}
                    multiline={question.multiline}
                    shuffle={question.shuffle}
                    correctAnswers={this.state.answers[id]}
                    saveAnswer={this.saveCorrectAnswer}
                    setMultiline={this.setMultiline}
                    setQuestion={this.setQuestion}
                    deleteQuestion={this.deleteQuestion}
                    points={question.points}
                    setPoints={this.setPoints}
                    moveUp={moveUp}
                    moveDown={moveDown}
                    isFirst={isFirst}
                    isLast={isLast}
                />)
        }

        if (question['type'] === "gap") {
            return (
                <GapQuestion
                    key={elementKey}
                    id={id}
                    number={number}
                    question={question.question}
                    subtasks={question.subtasks}
                    correctAnswers={this.state.answers[id]}
                    saveAnswer={this.saveCorrectAnswer}
                    words={question.words}
                    setQuestion={this.setQuestion}
                    deleteQuestion={this.deleteQuestion}
                    setAnswers={this.saveAnswers}
                    setSubtasks={this.setSubtasks}
                    setShuffle={this.setShuffle}
                    moveUp={moveUp}
                    moveDown={moveDown}
                    isFirst={isFirst}
                    isLast={isLast}
                />
            );
        }

        if (question['type'] === "select") {
            return (
                <SelectQuestion
                    key={elementKey}
                    id={id}
                    number={number}
                    question={question.question}
                    subtasks={question.subtasks}
                    options={question.options}
                    shuffle={question.shuffle}
                    correctAnswers={this.state.answers[id]}
                    setQuestion={this.setQuestion}
                    deleteQuestion={this.deleteQuestion}
                    saveAnswer={this.saveCorrectAnswer}
                    moveUp={moveUp}
                    moveDown={moveDown}
                    isFirst={isFirst}
                    isLast={isLast}
                />
            )
        }

        if (question['type'] === "header") {
            return (
                <Header
                    key={elementKey}
                    id={id}
                    header={question.header}
                    description={question.description}
                    moveUp={moveUp}
                    moveDown={moveDown}
                    isFirst={isFirst}
                    isLast={isLast}
                    setHeader={this.setHeader}
                    setDescription={this.setDescription}
                />
            );
        }
    }
}

export default TestEditor;